import { reactive } from 'vue';
import { UserKeycloak, UserKeyCloakResponse } from '@shared/types/user';

const user: UserKeycloak = reactive({
	merchantCode: '',
	merchantName: '',
	merchantToken: '',
	divisionCode: '',
	sellerCode: '',
	sellerName: '',
	email: '',
	firstName: '',
	lastName: '',
	preferredName: '',
	isAuthenticated: false,
	hasAccessToHomepage: false, // Checked against merchantCode TODO: remove when bookkeeping 2.0 is live
});

const verifyUserAttributes = (userInfo: UserKeyCloakResponse): [boolean, string] => {
	const payautCodePattern = new RegExp('^\\w{35}$');
	const merchantCodePattern = payautCodePattern;
	const divisionCodePattern = payautCodePattern;
	const merchantTokenPattern = new RegExp('^\\w{35}\\.\\w{35}$');
	const merchantNamePattern = new RegExp('^[\\w _/-]+$', 'i');

	if (merchantCodePattern.test(userInfo.merchantCode) !== true) {
		return [
			false,
			`User attributes verification failed: merchantCode does not match ${merchantCodePattern}`,
		];
	}
	if (divisionCodePattern.test(userInfo.divisionCode) !== true) {
		return [
			false,
			`User attributes verification failed: divisionCode does not match ${divisionCodePattern}`,
		];
	}
	if (merchantTokenPattern.test(userInfo.merchantToken) !== true) {
		return [
			false,
			`User attributes verification failed: merchantToken does not match ${merchantTokenPattern}`,
		];
	}
	if (merchantNamePattern.test(userInfo.merchantName) !== true) {
		return [
			false,
			`User attributes verification failed: merchantName does not match ${merchantNamePattern}`,
		];
	}

	return [true, 'User attributes successfully verified'];
};

const setUserInfo = (
	userInfo: UserKeyCloakResponse,
	isAuthenticated: boolean,
	hasAccessToHomepage: boolean
): void => {
	user.merchantName = userInfo.merchantName || '';
	user.merchantCode = userInfo.merchantCode || '';
	user.merchantToken = userInfo.merchantToken || '';
	user.divisionCode = userInfo.divisionCode || '';
	user.sellerName = userInfo.sellerName || '';
	user.sellerCode = userInfo.sellerCode || '';
	user.email = userInfo.email || '';
	user.firstName = userInfo.given_name || '';
	user.lastName = userInfo.family_name || '';
	user.isAuthenticated = isAuthenticated || false;
	user.preferredName = userInfo.preferred_username || '';
	user.hasAccessToHomepage = hasAccessToHomepage || false;
};

export default function UsersStore() {
	return {
		user,
		verifyUserAttributes,
		setUserInfo,
	};
}
